import useWidth from '@components/Hooks/useWidth';
import SidebarToggleIcon from '@components/v2/icons/SidebarToggle';
import Badge from '@components/v2/ui/Badge/Badge';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { DetailsToggleAlert } from '../../objectScreen.types';
import { useDetailsToggleStyles } from './detailsToggle.styles';

const ALERT_BADGE_SX = {
  '& .MuiBadge-badge': {
    padding: 0,
    minWidth: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
  },
};

interface DetailsToggleProps {
  isActive: boolean;
  disabled?: boolean;
  alert?: DetailsToggleAlert;
  testId?: string;
  onClick: () => void;
}

export const DetailsToggle = ({
  isActive,
  disabled,
  alert,
  testId,
  onClick,
}: DetailsToggleProps) => {
  const { translate } = useTranslation();
  const { smallWidth } = useWidth();
  const { classes } = useDetailsToggleStyles();

  if (smallWidth) {
    const iconToggle = (
      <IconButton
        icon={SidebarToggleIcon}
        color="secondary"
        shape="round"
        className={classes.toggle}
        isActive={isActive}
        ariaExpanded={isActive}
        disabled={disabled}
        ariaLabel={translate(LangEnum.GLOBAL_DETAILS_PANEL_TOGGLE)}
        testId={testId}
        onClick={onClick}
      />
    );

    return (
      <Tooltip TooltipContent={alert?.tooltip}>
        {alert ? (
          <Badge overlap="circular" badgeContent={alert.icon} sx={ALERT_BADGE_SX}>
            {iconToggle}
          </Badge>
        ) : (
          iconToggle
        )}
      </Tooltip>
    );
  }

  return (
    <Tooltip TooltipContent={alert?.tooltip}>
      <Button
        variant="contained"
        color="secondary"
        size="medium"
        className={classes.toggle}
        isActive={isActive}
        aria-expanded={isActive}
        disabled={disabled}
        testId={testId}
        onClick={onClick}
        startIcon={<Icon icon={SidebarToggleIcon} />}
        endIcon={alert?.icon}
      >
        {translate(LangEnum.GLOBAL_DETAILS)}
      </Button>
    </Tooltip>
  );
};
